export class PathwayRequirementsConstants{
    static unsaved_messages = 'You have made changes to the pathway requirement. Do you want to cancel and discard these changes?';
    static errors = {
        table : {
            required: 'At least one course must be specified for the pathway requirement. Please add a course or cancel out of your changes',
            duplicatedCourse: 'A course has been assigned multiple times for the pathway. Please select a different course to proceed.',
            duplicatedNonK12Course: 'A course has been assigned multiple times for the pathway. Please select a different course to proceed.',
        },
        course: {
            required: 'Course is a required field for the pathway requirement. Please enter/select a course from the available list',
            cleanRequired: 'Course is a required field for the pathway requirement. Please enter/select a course from the available list.',
        },
        form: {
            courseNameRequired: 'Course Name is a required field when using a non-K12 course in the pathway requirement. Please enter a course name.'
        }

    }
}
